import { render } from "./Spinner.vue?vue&type=template&id=4c6a0a3e&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=4c6a0a3e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6a0a3e"]])

export default __exports__